/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rating_None_AriaInputs */

const en_directory_rating_none_aria = /** @type {(inputs: Directory_Rating_None_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rating`)
};

const zh_directory_rating_none_aria = /** @type {(inputs: Directory_Rating_None_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无评分`)
};

/**
* | output |
* | --- |
* | "No rating" |
*
* @param {Directory_Rating_None_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rating_none_aria = /** @type {((inputs?: Directory_Rating_None_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rating_None_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rating_none_aria(inputs)
	return zh_directory_rating_none_aria(inputs)
});
export { directory_rating_none_aria as "directory.rating.none_aria" }